<div>
  <div id="kvp-player-title" class="m-b-15 text-white">{{ video.title }}</div>
  <div id="kvp-player" class="kvp_player"></div>
  <div id="kvp-player-close" class="position-fixed cursor-pointer" (click)="stop()">
    <span class="text-light me-2">Close</span>
    <ds365-icon svgName="close" status="light" svgSize="25"></ds365-icon>
  </div>
</div>
